<template>
  <div class="ordinaryModify custom">
    <el-dialog :popper-append-to-body="false" :close-on-click-modal="false" :visible.sync="watchSelectDialogVisible" :before-close="handleClose">
      <div
        class="ordinaryModifyChild"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="secBox">
          <div class="child" v-if="goldenWeighList && goldenWeighList.length > 0">
            <div class="selb">
              <span class="selb-title">{{ bandGoldenWeighList && bandGoldenWeighList.length > 0 ? '表盘金重：' : '金重：' }}</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="bandGoldenWeighList && bandGoldenWeighList.length > 0">
            <div class="selb">
              <span class="selb-title">表带金重：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.bandGoldenWeigh" size="small" @change="getSizeRange($event, 'bandGoldenWeigh')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in bandGoldenWeighList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child" v-if="bandColorList && bandColorList.length > 0">
            <div class="selb">
              <!-- <span class="inchesTips" v-if="bandColorList && bandColorList[0].includes('寸')">(1英寸＝2.54厘米)</span> -->
              <span class="selb-title">表带颜色：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.bandColor" size="small" @change="getSizeRange($event, 'bandColor')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in bandColorList" :key="item" :value="item" :label="item">{{ item }}</el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="child">
            <div class="selb">
              <span class="selb-title">商品数量：</span>
              <el-input-number
                :min="1"
                :max="amendDuplication.spotFlag == 2 ? 9999 : optionsList.stockQuantity"
                v-model="amendDuplication.quantity"
                @change="getSizeRange($event, 'quantity')"
              ></el-input-number>
              <span class="inchesTips" v-if="amendDuplication.spotFlag == 1">库存：{{ optionsList.stockQuantity || 0 }}件</span>
            </div>
          </div>
          <div class="child remorkBox">
            <div class="selb">
              <span class="selb-title">备注：</span>
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入内容" v-model="amendDuplication.productRemark"> </el-input>
            </div>
          </div>
          <div class="child" v-if="tradePrice && hasPriceViewPermission()">
            <div class="selb">
              <span class="selb-title">结算金额：</span>
              <span>{{ tradePrice }}</span>
            </div>
          </div>
          <div class="child" v-if="labelPrice && (!amendDuplication.exclusivePrice || amendDuplication.exclusivePrice == 0)">
            <div class="selb">
              <span class="selb-title">标签价格：</span>
              <span>{{ labelPrice }}</span>
            </div>
          </div>
          <div class="child" v-if="amendDuplication.exclusivePrice && amendDuplication.exclusivePrice != 0">
            <div class="selb">
              <span class="selb-title">尊享价格：</span>
              <span>{{ amendDuplication.exclusivePrice }}</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="btnFlag" class="modifyCart" @click.stop="updateCpoyCart('修改')">确定修改</el-button>
        <!-- <el-button :loading="btnFlag" class="copyCart" @click.stop="updateCpoyCart('复制')">新增商品</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { modifyCartPublic } from '@/api/cartApi';
import { deepClone } from '@/utils/util';
import { debounce } from '@/utils/index';
import ls from '@/utils/localStorage';
export default {
  props: {
    watchSelectDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {};
      },
    },
    product: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      optionsList: {},
      amendDuplication: {
        tradePrice: '', //传给后端
        labelPrice: '', //传给后端
        exclusivePrice: '', //传给后端
        bandGoldenWeigh: '',
      },
      btnFlag: false,
      goldenWeighList: [],
      bandColorList: [],
      bandGoldenWeighList: [], //表带金重
      tradePrice: '', //页面展示
      labelPrice: '', //页面展示
      loading: false,
    };
  },
  mounted() {
    this.amendDuplication = deepClone(this.modifyingReplication);
    this.getOptional();
  },
  methods: {
    // 金重排序
    mainStoneSort(list) {
      // 1. 将每个区间字符串解析为对象
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range }; // 保留原始字符串以便最后恢复
      });
      // 2. 根据 start 值进行排序
      parsedRanges.sort((a, b) => a.start - b.start);
      // 3. 提取排序后的原始字符串
      return parsedRanges.map((item) => item.range);
    },
    // 获取可选属性
    getOptional() {
      let obj = {
        styleNumber: this.amendDuplication.styleNumber,
        gender: this.amendDuplication.gender,
        classify: this.amendDuplication.classify,
        spotFlag: this.amendDuplication.spotFlag,
        cartId: this.amendDuplication.id,
        requestFrom: 1,
        sequence: this.amendDuplication.sequence,
      };
      getOptional(obj).then((res) => {
        this.optionsList = { ...this.optionsList, ...res.data };
        this.optionsList.stockQuantity = 0;
        if (this.amendDuplication.isCouples == 2) {
          this.goldenWeighList = this.mainStoneSort(res.data.goldenWeigh);
          this.bandColorList = res.data.bandColor;
          this.bandGoldenWeighList = res.data.bandGoldenWeigh ? this.mainStoneSort(res.data.bandGoldenWeigh) : [];
        } else {
          this.goldenWeighList = this.mainStoneSort(res.data.couplesMap[this.amendDuplication.gender]['goldenWeigh']);
          this.bandColorList = res.data.couplesMap[this.amendDuplication.gender]['bandColor'];
        }
        this.goldenWeighList.forEach((res) => {
          if (this.amendDuplication.goldWeigh?.indexOf('-') > 0) {
            if (
              res?.indexOf('-') > 0 &&
              Number(res.split('-')[0]) <= Number(this.amendDuplication.goldWeigh.split('-')[0]) &&
              Number(res.split('-')[1]) >= Number(this.amendDuplication.goldWeigh.split('-')[0])
            ) {
              return (this.amendDuplication.goldWeigh = res);
            }
          } else {
            if (
              res?.indexOf('-') > 0 &&
              Number(res.split('-')[0]) <= Number(this.amendDuplication.goldWeigh) &&
              Number(res.split('-')[1]) >= Number(this.amendDuplication.goldWeigh)
            ) {
              return (this.amendDuplication.goldWeigh = res);
            }
          }
        });
        this.getPriceRange();
      });
    },
    getSizeRange(value, type) {
      this.amendDuplication[type] = value;
      this.getPriceRange();
    },
    // 复制修改商品
    updateCpoyCart(text) {
      let type = '';
      let obj = {};
      if (!this.amendDuplication.quantity) {
        return this.$message({
          message: '数量不能为0',
          type: 'warning',
          duration: 500,
        });
      }
      if (text === '修改') {
        type = 'put';
      } else {
        obj = {
          productDtoList: [this.amendDuplication],
          shopType: 3,
          type: 2,
          orderPath: 1,
          requestFrom: 1,
          spotFlag: this.amendDuplication.spotFlag,
          purchaseSource: ls.get('coludQuery') ? 0 : 1, //0 云平台产品推荐, 1 其他渠道"
          siteId: ls.get('siteId') || ls.get('userInfo').sysUser?.siteId || '',
        };
        type = 'post';
      }
      modifyCartPublic(text === '修改' ? this.amendDuplication : obj, type).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: text === '修改' ? '修改成功' : '复制成功',
            type: 'success',
            duration: 1500,
          });
          // 修改购物车数据
          this.$emit('updataCart');
          // 关闭弹窗
          this.$emit('onCloseSelectDialog');
        }
      });
    },
    // 实时监听 防抖debounce
    onNative: debounce(
      function (event) {
        if (Number(event.target.value)) {
          if (this.amendDuplication.spotFlag == 2 && event.target.value > 9999) {
            this.amendDuplication.quantity = 9999;
          } else if (this.amendDuplication.spotFlag == 1 && event.target.value > this.optionsList.stockQuantity) {
            this.amendDuplication.quantity = this.optionsList.stockQuantity;
          }
        }
      },
      500,
      true
    ),
    //获取价格范围
    getPriceRange() {
      this.btnFlag = true;
      this.loading = true;
      const obj = deepClone(this.amendDuplication);
      delete obj.texture;
      getPriceRangeSpot(obj)
        .then((res) => {
          this.tradePrice = res.data.tradePrice;
          this.labelPrice = res.data.labelPrice;
          this.amendDuplication.tradePrice = res.data.tradePrice;
          this.amendDuplication.labelPrice = res.data.labelPrice;
          this.amendDuplication.exclusivePrice = res.data.exclusivePrice;
          this.optionsList.stockQuantity = res.data.stockQuantity;
          this.btnFlag = false;
          this.loading = false;
        })
        .catch(() => {
          this.btnFlag = false;
          this.loading = false;
        });
    },
    handleClose() {
      this.$emit('onCloseSelectDialog');
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  ::v-deep .el-dialog {
    width: 900px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .ordinaryModifyChild {
    display: flex;
  }

  ::v-deep .el-select > .el-input {
    width: 300px;
  }

  .secBox {
    width: 100%;
  }

  .remorkBox {
    margin-top: 25px !important;
  }

  .child {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .selb {
      // height: 40px;
      // line-height: 40px;
      display: flex;
      align-items: center;
      // width: 400px;

      .el-radio-group {
        // margin-left: 20px;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #ec9368;
        background: #ec9368;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #ec9368;
      }

      span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        min-width: 70px;
      }
      .selb-title {
        text-align: right;
      }
    }
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
  }
}

::v-deep .el-select-dropdown__item {
  padding: 0;
  height: auto;
}

::v-deep .el-select-dropdown__list {
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}

::v-deep .el-input__inner {
  color: #ec9368;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}

::v-deep .el-input-number {
  width: 300px;
}

::v-deep .el-icon-minus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-icon-plus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-textarea__inner {
  width: 760px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-button span {
  font-size: 14px;
}

.modifyCart {
  background: #87ceeb;
  color: #fff;
  border: none;
}

.copyCart {
  background: #ec9368;
  color: #fff;
  border: none;
  margin-left: 20px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
}
.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }
  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 8px;
  }
  .material {
    // width: 800px;
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }
  ::v-deep.el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }
  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }
  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
